import React from "react";

const NotFound = () => {
    return <div>404-Not found</div>;
};

export default NotFound;
